<template>
  <div>
    <c-pagination
      v-model="page"
      :per-page="perPage"
      :total="publications.total"
      mini
      class="publications-pagination"
    />
    <div class="clearfix" />
    <div class="overlay-wrapper">
      <div class="row publications">
        <publication-preview
          v-for="item of publicationsSorted"
          :key="item.ID"
          :data="item"
          :detail-route-name="detailRouteName"
          :more-text="moreText"
          class="col-xs-12 col-lg-3"
        />
      </div>
      <no-data
        v-if="!publicationsNotEmpty && !publications.fetching"
      />
      <c-loading-overlay v-if="publications.fetching" />
    </div>
    <div class="row text-center">
      <button
        v-if="publicationsNotEmpty && page < Math.ceil(publications.total / perPage)"
        class="btn-lg background-white border-danger text-danger"
        :disabled="publications.fetching"
        @click="page++"
      >
        <c-spinner v-if="publications.fetching" /> Следующая страница
      </button>
    </div>
  </div>
</template>

<script>
import CSpinner from '../components/ui/CSpinner'
import CLoadingOverlay from '../components/ui/CLoadingOverlay'
import CPagination from '../components/ui/CPagination'
import NoData from '../components/NoData'
import PublicationPreview from '../components/PublicationPreview'
import publications from '../mixins/publications'

export default {
  name: 'Publications',
  components: { PublicationPreview, NoData, CLoadingOverlay, CSpinner, CPagination },
  mixins: [publications],
  props: {
    type: {
      type: String,
      required: true,
      validator (value) {
        return [
          'news',
          'articles'
        ].includes(value)
      }
    },
    sectionId: {
      type: String,
      default: ''
    },
    detailRouteName: {
      type: String,
      required: true
    },
    moreText: {
      type: String,
      default: 'Подробнее'
    }
  },
  data () {
    return {
      page: 1,
      perPage: 8
    }
  },
  watch: {
    page () {
      this.fetchPublications(this.type, this.page, this.perPage, this.sectionId)
    }
  },
  mounted () {
    this.fetchPublications(this.type, this.page, this.perPage, this.sectionId)
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

h2 {
  float: left;
}

.publications-pagination {
  float: right;
  margin-top: 20px;
}

.publications {
  display: flex;
  flex-wrap: wrap;
}
.publications > div {
  padding: 15px;
}

.overlay-wrapper {
  margin-bottom: 15px;
  @media (max-width: $xsBreakpoint) {
    margin-bottom: 0;
  }
}
</style>
